<template>
    <div name="card2" class="card">
        <span class="title">“전용 앱이 따로 있으면 좋겠어요"</span>
        <span class="description" style="margin-top: 8px;">솔닥 컨시어지<br>전용 앱 출시</span>
        <img class="image" src="../../../../assets/improvement_5.png" />
        <div class="button" @click="go" style="margin-top: 8px;">
            자세히 보기
        </div>
    </div>
</template>

<script>
export default {
    name: 'card1',
    methods: {    
        go: function()
        {
            window.open("https://blog.naver.com/soldoc_concierge/224316139269", "_blank")
        }

    }

}
</script>

<style scoped>
    .card {
        width: 100%;
        display: flex;
        padding: 20px 5px 20px 16px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        position: relative;
        border-radius: 18px;
        border: 1px solid var(--Gray-00, #FFF);
        background: var(--Gray-20, #F3F5F8);
    }
    .image {
        position: absolute;
        width: 154px;
        top: 10px;
        right: 20px;
    }
    .title {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 114.286% */
        width: 50%;
    }
    .description {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .button {
        display: flex;
        height: 30px;
        padding: 8px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/m_uncomfortable/improvements/Card5.vue